import { Link } from "react-router-dom";
import Marque from "@/components/Marque";
import ThemeSwitch from "@/components/ThemeSwitch";
import SourcePreferee from "@/components/SourcePreferee";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

/**
 * Cadre commun des calculateurs gratuits : en-tête, pied de page, et surtout
 * le bloc qui renvoie d'un outil à l'autre.
 *
 * Ce maillage n'est pas décoratif. Un couvreur qui cherche « how many shingles
 * in a bundle » a le même toit en tête que celui qui cherche la pente : les
 * trois pages se nourrissent mutuellement, et Google lit ces liens comme le
 * signe qu'il s'agit d'un ensemble cohérent plutôt que de trois pages isolées.
 *
 * Anglais seulement, comme les pages qu'il habille : les requêtes visées sont
 * américaines.
 */

const CONTACT = "quotes@roofborder.com";
const TEL_AFFICHE = "1-866-4ROOF-21";
const TEL_LIEN = "tel:+18664766321";

export const OUTILS = [
  {
    href: "/roof-pitch-calculator",
    titre: "Roof Pitch Calculator",
    sous: "Rise and run into degrees, percent and the pitch multiplier.",
  },
  {
    href: "/roofing-square-calculator",
    titre: "Roofing Square Calculator",
    sous: "Square feet into roofing squares, waste included.",
  },
  {
    href: "/shingle-bundle-calculator",
    titre: "Shingle Bundle Calculator",
    sous: "How many bundles, starter and ridge cap to order.",
  },
];

export default function CoquilleOutil({ actuel, children }) {
  const autres = OUTILS.filter((o) => o.href !== actuel);
  return (
    <div className="min-h-screen bg-app text-ink">
      <header className="border-b border-line">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
          <Marque taille="sm" />
          <div className="flex items-center gap-4">
            <ThemeSwitch />
            <Link to="/login" className="text-sm text-ink-soft hover:text-ink transition-colors">
              Sign in
            </Link>
            <Link to="/measure">
              <Button className="rounded-md h-9 px-4">Measure a roof</Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12">{children}</main>

      <section className="max-w-5xl mx-auto px-6 pb-16">
        <h2 className="text-lg font-bold">Other free tools</h2>
        <div className="mt-4 grid sm:grid-cols-2 gap-4">
          {autres.map((o) => (
            <Link
              key={o.href}
              to={o.href}
              className="rounded-xl border border-line bg-surface p-5 hover:bg-hover transition-colors"
            >
              <div className="font-bold">{o.titre}</div>
              <div className="mt-1 text-sm text-ink-soft">{o.sous}</div>
            </Link>
          ))}
        </div>
      </section>

      <footer className="border-t border-line">
        <div className="max-w-5xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-ink-faint">
          <span>© {new Date().getFullYear()} Roof Border</span>
          <div className="flex items-center gap-4">
            <a href={TEL_LIEN} className="inline-flex items-center gap-1 hover:text-ink transition-colors">
              <Phone className="h-3.5 w-3.5" /> {TEL_AFFICHE}
            </a>
            <a href={`mailto:${CONTACT}`} className="hover:text-ink transition-colors">{CONTACT}</a>
            <Link to="/privacy" className="hover:text-ink transition-colors">Privacy</Link>
            <SourcePreferee lang="en" />
          </div>
        </div>
      </footer>
    </div>
  );
}
